<div class="flex flex-col -m-6">

    <!-- Header -->
    <div
        class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'scheduleDTypeToGoLiveDialog.title' | transloco }}</div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <ng-container>
        <div class="flex flex-col p-6">
            <mat-label class="font-medium mb-2">{{ 'scheduleDTypeToGoLiveDialog.date' | transloco }}</mat-label>
            <mat-form-field class="flex flex-col w-full items-center cursor-pointer">
                <input readonly matInput [formControl]="date" 
                    [min]="datemin"
                    [matDatepicker]="datepicker"
                    (click)="openDatepickerOnClick(datepicker)">
                <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker [startView]="'month'"></mat-datepicker>
            </mat-form-field>
            <div class="flex flex-col w-full items-center cursor-pointer">
                <timepicker-autofill-component [control]="formGroup.controls['time']" [allowManual]="false" [minuteStep]="30" 
                                        [style]="'HH:mm'"></timepicker-autofill-component>
            </div>
            <mat-label class="font-medium mb-2">{{ 'scheduleDTypeToGoLiveDialog.observations' | transloco }}</mat-label>
            <mat-form-field class="w-full">
                <textarea matInput [formControl]="observations"
                    [rows]="3" [cols]="1"></textarea>
            </mat-form-field>
        </div>
    </ng-container>

    <!-- Actions -->
    <div class="flex flex-col sm:flex-row justify-end gap-2 px-4 pb-2 sm:px-8 sm:pb-8 w-full">
        <button (click)="closeDialog()" mat-stroked-button>
            {{ 'cancel' | transloco }}
        </button>
        <button (click)="save()" mat-flat-button color="primary">
            {{ 'accept' | transloco }}
        </button>
    </div>
</div>